/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export const go = createAction(
  '[Router] Go',
  props<{
    path: any[];
    query?: any;
    extras?: NavigationExtras;
  }>()
);
export const back = createAction('[Router] Back');
export const forward = createAction('[Router] Forward');
export const noAction = createAction('[Router] No Action');
